import { __rest } from "tslib";
import React, { PureComponent } from 'react';
import BaseTip from './BaseTip';
import { TipTheme } from './TipTypes';
import PROPS_FORMATE_MAPPING from './PropsFormat';
export default class Tip extends PureComponent {
    constructor() {
        super(...arguments);
        this.getPropsFromType = () => {
            let _a = this.props, { leftIcon, customStyle, themeType, type, title, rightText } = _a, props = __rest(_a, ["leftIcon", "customStyle", "themeType", "type", "title", "rightText"]);
            customStyle = customStyle
                ? customStyle
                : TipTheme[themeType];
            const HELPER = PROPS_FORMATE_MAPPING[type] ? PROPS_FORMATE_MAPPING[type] : PROPS_FORMATE_MAPPING[1];
            return HELPER(leftIcon, customStyle, title, rightText, props);
        };
    }
    render() {
        let props = this.getPropsFromType();
        return <BaseTip {...props}/>;
    }
}
Tip.defaultProps = {
    mode: '',
    type: 0,
    numberOfLines: 1,
    layoutType: 1,
    themeType: 'warning',
    onPress() { },
    needScale: false
};
